<template>
  <VTextarea
    v-bind="$attrs"
    v-on="$listeners"
    :label="_label"
    :placeholder="_placeholder"
    :rules="_rules"
    ref="origin"
  >
    <!--   :label="$t($attrs.label)" 하면 텍스트 입력할때마다 translate function 이 실행하게 되기 때문에
  귀찮더라도 프롭스랑 컴퓨티드로 빼기 -->
    <slot v-for="slot in Object.keys($slots)" :name="slot" :slot="slot" />
    <template v-for="(index, name) in $scopedSlots" v-slot:[name]="data">
      <slot :name="name" v-bind="data"></slot>
    </template>
  </VTextarea>
</template>
<script>
import { isFunction, isString } from '@/utils/util';

export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    rules: {
      type: Array,
    },
  },
  mounted() {
    Object.assign(
      this,
      Object.entries(this.$refs.origin).reduce((a, [name, value]) => {
        if (isFunction(value) && !this.hasOwnProperty(name)) {
          a[name] = (...args) => value.apply(this.$refs.origin, args);
        }

        return a;
      }, {}),
    );
  },

  computed: {
    _label() {
      return this.$t(this.label);
    },
    _placeholder() {
      return this.$t(this.placeholder);
    },
    _rules() {
      return !this.rules
        ? []
        : this.rules.map(validation => {
            if (isFunction(validation))
              return text => {
                const result = validation(text);
                return isString(result) ? this.$t(result) : result;
              };
            else if (isString(validation)) return this.$t(validation);
            else return validation;
          });
    },
  },
};
</script>
